export default {
  en: {
    are_you_missing_a_feature: "Are you missing a feature?",
    share_your_ideas_and_suggestions:
      "Share your ideas and suggestions with us to improve ChronoFox. We are always looking for ways to make our application better. You will receive a statement on your suggestion and we will inform you about the implementation status.",
    contact_us: "Contact us",

    featurelist: {
      timetracking: "Timetracking",
      timetracking_description:
        "This one seems obvious, but it's the core feature of ChronoFox. Track your time spent on projects, tasks, and activities with start, stop, and pause times.",

      customers_timelogs: "Customers & Timelogs",
      customers_timelogs_description:
        "Keep track of your customers in timelogs, projects and reports. Assign timelogs and project to customers to get detailed reports about customers.",

      projects: "Projects",
      projects_description:
        "Create projects track time spent on projects and improve your project management. You can track project budget and use the analytics to improve your project workflow.",

      multi_user_support: "Multi-User Support",
      multi_user_support_description:
        "Collaborate with your team members on projects. Track time together and improve your workflow.",

      billing_invoicing: "Billing and Invoicing",
      billing_invoicing_description:
        "When wanting to invoice based on your time tracking data, you can mark timelogs as billable and billed.",

      detailed_analytics: "Detailed Analytics",
      detailed_analytics_description:
        "Analyze your time tracking data with detailed analytics. Get insights into your projects, customers, activities and overall company.",

      user_management: "User Management",
      user_management_description:
        "Manage your team members. Add and remove team members on the fly. You only pay for the team members you have in your account and the exact time they are existing in your account.",

      reports: "Reports",
      reports_description:
        "Generate detailed reports for your projects, customers, and activities. Export them as PDF or CSV.",

      calendar: "Calendar",
      calendar_description:
        "View your and your team's timelogs and projects in a calendar view. Plan your time and projects more efficiently.",

      billing: "Comprehensible billing",
      billing_description:
        "We offer a transparent billing process. You can view your billing-periods and your user-subscriptions within those periods at any time.",

      hourly_rates_rules: "Hourly Rates & Rules",
      hourly_rates_rules_description:
        "Set hourly rates for your customers and projects. Define rules for your timelogs to automatically assign hourly rates based on conditions and order.",

      support: "Support",
      support_description:
        "Our support team is here to help you. If you have any questions or issues, feel free to contact us any time. As a business customer, you will get priority support.",
    },
  },
  de: {
    are_you_missing_a_feature: "Fehlt dir ein Feature?",
    share_your_ideas_and_suggestions:
      "Teile uns deine Ideen und Vorschläge mit, um ChronoFox zu verbessern. Wir sind immer auf der Suche nach Wegen, unsere Anwendung zu verbessern. Du erhältst eine Stellungnahme zu deinem Vorschlag und wir informieren dich über den Implementierungsstatus.",
    contact_us: "Kontaktiere uns",

    featurelist: {
      timetracking: "Zeiterfassung",
      timetracking_description:
        "Dies scheint offensichtlich zu sein, aber es ist die Kernfunktion von ChronoFox. Erfasse deine auf Projekte, Aufgaben und Aktivitäten verwendete Zeit mit Start-, Stopp- und Pausenzeiten.",

      customers_timelogs: "Kunden & Zeiterfassung",
      customers_timelogs_description:
        "Behalte den Überblick über deine Kunden in Zeiterfassungen, Projekten und Berichten. Weise Zeiterfassungen und Projekte Kunden zu, um detaillierte Berichte über Kunden zu erhalten.",

      projects: "Projekte",
      projects_description:
        "Erstelle Projekte, verfolge die auf sie verwendete Zeit und verbessere dein Projektmanagement. Du kannst Projektbudgets verfolgen und die Analysen nutzen, um deine Arbeitsabläufe zu optimieren.",

      multi_user_support: "Mehrbenutzerunterstützung",
      multi_user_support_description:
        "Arbeite mit deinen Teammitgliedern an Projekten zusammen. Erfasst gemeinsam Zeiten und verbessert euren Workflow.",

      billing_invoicing: "Abrechnung und Rechnungsstellung",
      billing_invoicing_description:
        "Wenn du basierend auf deinen Zeiterfassungsdaten Rechnungen stellen möchtest, kannst du Zeiterfassungen als abrechenbar und abgerechnet markieren.",

      detailed_analytics: "Detaillierte Analysen",
      detailed_analytics_description:
        "Analysiere deine Zeiterfassungsdaten mit detaillierten Analysen. Erhalte Einblicke in deine Projekte, Kunden, Aktivitäten und dein gesamtes Unternehmen.",

      user_management: "Benutzerverwaltung",
      user_management_description:
        "Verwalte deine Teammitglieder. Füge Teammitglieder hinzu oder entferne sie jederzeit. Du zahlst nur für die Teammitglieder, die in deinem Konto existieren, und nur für die Zeit, die sie aktiv sind.",

      reports: "Berichte",
      reports_description:
        "Erstelle detaillierte Berichte für deine Projekte, Kunden und Aktivitäten. Exportiere sie als PDF oder CSV.",

      calendar: "Kalender",
      calendar_description:
        "Betrachte deine und die Zeiterfassungen und Projekte deines Teams in einer Kalenderansicht. Plane deine Zeit und Projekte effizienter.",

      billing: "Nachvollziehbare Abrechnung",
      billing_description:
        "Wir bieten einen transparenten Abrechnungsprozess. Du kannst jederzeit deine Abrechnungszeiträume und Benutzerabonnements innerhalb dieser Zeiträume einsehen.",

      hourly_rates_rules: "Stundensätze & Regeln",
      hourly_rates_rules_description:
        "Setze Stundensätze für deine Kunden und Projekte fest. Definiere Regeln für deine Zeiterfassungen, um Stundensätze basierend auf Bedingungen und Reihenfolge automatisch zuzuweisen.",

      support: "Support",
      support_description:
        "Unser Support-Team ist für dich da. Wenn du Fragen oder Probleme hast, kannst du uns jederzeit kontaktieren. Als Geschäftskunde erhältst du vorrangigen Support.",
    },
  },
};
